import { SidePopupLayout } from "src/component/SidePopupLayout"
import { AppSpan, AppText, CustomContainer, FlexRow, GridContainer, Icon, ScreenTitle } from "src/style"
import { ussdBanks } from "src/utils/mock-data"
import { banksImgSm } from "src/utils/logo"
import { SmLogoCreation } from "src/component"

export const UssdBanks: React.FC<any> = ({handleBank, next, close}) => {

    function handleSelection (info: any) {
        handleBank(info)
        next()
    }

    return (
        <SidePopupLayout close={close}>
            <ScreenTitle textSize="2.2" fontWeight="700">Fund with USSD</ScreenTitle>
            <CustomContainer topMargin='2.5'>
                <AppSpan>Choose your bank to start payment</AppSpan>
                <CustomContainer topMargin="2">
                    {
                        ussdBanks?.map((item, index) => {
                            return (
                                <GridContainer
                                    minHeight="7" radius="0.8" borderColor="#EAECF0"
                                    padding="1.5" topPadding="1" bottomPadding="1"
                                    bottomMargin="2" key={index} 
                                    onClick={() => handleSelection(item)}
                                >
                                    <FlexRow gap="2" justifyContent="space-between">
                                        <AppText fontWeight="600" color="#101828" cursor="pointer">{item.bank} {item.code}</AppText>
                                        { banksImgSm[item?.bank] ?
                                            <Icon src={banksImgSm[item?.bank]} /> 
                                            : <SmLogoCreation name={item.bank} />
                                        }
                                    </FlexRow>
                                </GridContainer>
                            )
                        })
                    }
                </CustomContainer>
            </CustomContainer>
        </SidePopupLayout>
    )
}